var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2a4 4 0 00-4 4v19.97a4 4 0 004 4h19.97a4 4 0 004-4V6a4 4 0 00-4-4H6zm16.511 6l-5.584 6.351L23 23h-4.467l-4.09-5.824L9.324 23H8l5.856-6.66L8 8h4.467l3.872 5.515L21.188 8h1.323zm-7.99 7.582l.594.831 4.041 5.657h2.033l-4.953-6.932-.593-.83-3.81-5.333H9.8l4.721 6.607z",
    fill: "#000"
  })));
}

export default SvgIconSnsTwitter;